const TOKEN_KEY = 'access_token';

const stripToken = (token: string): string => token.replaceAll('"', '');

/**
 * Reads the Auth0 ID token persisted by AuthPageComponentWrapper on login.
 * Shared by apiClient (Authorization header) and the BRG assistant session/
 * chat hooks (X-User-Token header / WS auth frame).
 */
export function getAuthToken(): string | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(TOKEN_KEY);
  return raw ? stripToken(raw) : null;
}
